import React from 'react'
import { BookOpen } from '@phosphor-icons/react'

interface LogoProps {
  className?: string
  size?: 'sm' | 'md' | 'lg'
}

export function Logo({ className = '', size = 'md' }: LogoProps) {
  const sizeClasses = {
    sm: 'text-xl',
    md: 'text-2xl', 
    lg: 'text-3xl'
  }

  const iconSizes = {
    sm: 20,
    md: 28,
    lg: 36
  }

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <BookOpen size={iconSizes[size]} className="text-game-accent dark:text-violet-400" />
      <div className="flex flex-col">
        <h1 className={`font-bold text-game-primary dark:text-zinc-100 leading-tight ${sizeClasses[size]}`}>EDURPG.IA</h1>
        <span className="text-game-muted dark:text-zinc-400 text-xs leading-tight">Plataforma Inteligente de RPG de Mesa</span>
      </div>
    </div>
  )
}